<template>
  <div :class="[className]">
    <a-tabs :type="type" @change="(key) => $emit('change', key)" :activeKey="activeKey">
      <slot name="content"></slot>
    </a-tabs>
  </div>
</template>

<script>
import { TABS_TYPE, TABS_SIZE } from "@/utils";
export default {
  name: "Tabs",
  props: {
    type: {
      type: String,
      default: "line",
      validator: function(value) {
        return TABS_TYPE.includes(value);
      },
    },
    activeKey: {
      type: String,
    },
    size: {
      type: String,
      default: "default",
      validator: function(value) {
        return TABS_SIZE.includes(value);
      },
    },
    className: {
      type: [String],
    },
  },
  methods: {},
};
</script>
